import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import ReactApexChart from "react-apexcharts";
import {MaterialReactTable} from 'material-react-table';
import PropTypes from 'prop-types';
// import { S3Client, GetObjectCommand } from "@aws-sdk/client-s3";
// import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
// import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION, AWS_BUCKET } from "../Global";
import Header from "../layouts/CustomerHeader";
import Sidebar from "../layouts/CustomerSidebar";
import axios from "../api/axios";
import {  Apitoken, Authtoken,season_id } from "../Global";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import Select from "react-select";

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
// import { DateRangePicker } from 'rsuite';
// import 'rsuite/dist/rsuite.min.css';

const CustomerDashboard = () => {
  //const [menu, setMenu] = useState(false);
  const [cusomerbalance, setCusomerbalance] = useState([]);
  const [dataacaliber, setDataacaliber] = useState([]);
  const [dataBoxes, setDataBoxes] = useState([]);
  const [allseason, setAllseason] = useState([]);
  const [invoicedata, setInvoicedata] = useState([]);
  // const [predefinedRanges, setPredefinedRanges] = useState([]);
  
  let customer_id = localStorage.getItem("customer_id");
  let customer_info = JSON.parse(localStorage.getItem("customer_info"));
 
    ///const [value, setValue] = useState(null);
 const [formData, setFormData] = useState({
    customer_id:customer_id,
    season_id:season_id,
    start_date: '',
    end_date: '',
  });

console.log(season_id);
   useEffect(() => {
      axios.post("/customerportal/dasboard/all-seasons",{},{  headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },})
        .then((response) => {
          if (response.data.code === 200) {
              let seasonss = response.data.data.seasons;
              let currencieslist = seasonss.map((customer) => ({
                  label: customer.name,
                  value: customer.id,
                }));
              setAllseason(currencieslist);
            }
        }).catch((error) => {
          console.log(error);
        });
    }, []);

  
    useEffect(() => {

      axios.post("/customerportal/dasboard/boxes",formData,{  headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },})
        .then((response) => {
          if (response.data.code === 200) {
            setDataBoxes(response.data.data.boxes);
          }else{
            setTimeout(() => {
             // window.location.href = "/customerportal/login";
            }, 500);
          }
        }).catch((error) => {
          console.log(error);
        });
      axios.post("/customerportal/dasboard/customer-invoices",formData,{  headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },})
        .then((response) => {
          if (response.data.code === 200) {
            setInvoicedata(response.data.data.invoices);
          }else{
            setTimeout(() => {
              window.location.href = "/customerportal/login";
            }, 500);
          }
        }).catch((error) => {
          console.log(error);
        });


        
      axios.post("/customerportal/dasboard/customer-loading",formData,{  headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },})
        .then((response) => {
          if (response.data.code === 200) {
            setCusomerbalance(response.data.data.loadings);
          }
        })  .catch((error) => {
          console.log(error);
        });

      axios.post("/customerportal/dasboard/customer-caliber",formData,{headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },} )
        .then((response) => {
          setDataacaliber(response.data.data);
      
          })  .catch((error) => {
            console.log(error);
          });

    }, []);

        
      
const sColStacked_caliber = {
  chart: {
    type: "bar",
    height: 350,
    stacked: false,      // ← disable stacking
    toolbar: { show: false },
  },
  colors: ['#1B2E6B', '#0070C0'], 
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: '50%', // make them a bit wider since they're no longer stacked
    },
  },
  series: [
    {
      name: "Quantity",
      data: dataacaliber.quantity || [],
    },
    {
      name: "Remaining Quantity",
      data: dataacaliber.remaining_quantity || [],
    },
  ],
  xaxis: {
    type: "category",
    categories: dataacaliber.products || [],
    labels: {
      rotate: -45,
      style: { fontSize: "12px" },
    },
  },
  legend: {
    show: true,
    position: "bottom",
    horizontalAlign: "center",
    offsetY: 10,
  },
  yaxis: {
    labels: {
      formatter: (val) => `${val} kg`,
      style: { fontSize: "12px" },
    },
  },
  responsive: [
    {
      breakpoint: 480,
      options: {
        legend: {
          position: "bottom",
          offsetX: -10,
          offsetY: 0,
        },
      },
    },
  ],
};

  const downloadpdf = () => {
  const input = document.getElementById('downloadpdf');

  html2canvas(input, { scale: 2 }).then((canvas) => {
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');

    const imgWidth = 210;
    const pageHeight = 297;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }
  const today = new Date();
  const formattedDate = today.toISOString().split('T')[0]; // YYYY-MM-DD
  const fileName = `Admin Dashboard ${formattedDate}.pdf`;
    pdf.save(fileName);
  });
};
const toggleMobileMenu = () => {
console.log(234)
}


const handleSelectChangeCustomer = (selectedOption) => {
  const updatedFormData = {
    ...formData,
    season_id: selectedOption ? selectedOption.value : null,
  };

  localStorage.setItem("season_id", updatedFormData.season_id);
  setFormData(updatedFormData);

  console.log(updatedFormData); // Logs the correct data

  axios.post("/customerportal/dasboard/boxes", updatedFormData, {
    headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
  })
  .then((response) => {
    if (response.data.code === 200) {
      setDataBoxes(response.data.data.boxes);
    } else {
      setTimeout(() => {
      //  window.location.href = "/customerportal/login";
      }, 500);
    }
  })
  .catch((error) => {
    console.log(error);
  });
axios.post("/customerportal/dasboard/customer-invoices",updatedFormData,{  headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },})
        .then((response) => {
          if (response.data.code === 200) {
            setInvoicedata(response.data.data.invoices);
          }else{
            setTimeout(() => {
              window.location.href = "/customerportal/login";
            }, 500);
          }
        }).catch((error) => {
          console.log(error);
        });
  axios.post("/customerportal/dasboard/customer-loading", updatedFormData, {
    headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
  })
  .then((response) => {
    if (response.data.code === 200) {
      setCusomerbalance(response.data.data.loadings);
    }
  })
  .catch((error) => {
    console.log(error);
  });

  axios.post("/customerportal/dasboard/customer-caliber", updatedFormData, {
    headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
  })
  .then((response) => {
    setDataacaliber(response.data.data);
  })
  .catch((error) => {
    console.log(error);
  });
};
  
const InvoiceLink = ({ row }) => (
  <a href={`/customerportal/invoices-payments-view/${row.original.id}`}>
    {row.original.invoice_number}
  </a>
);

InvoiceLink.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      invoice_number: PropTypes.string,
    }),
  }).isRequired,
};

const TotalPaidLink = ({ row }) => (
  <a href={`/customerportal/invoices-payments-all-view/${row.original.id}`}>
    {row.original.paid}
  </a>
);

TotalPaidLink.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      paid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  }).isRequired,
};

const CreditNoteLink = ({ row }) => {
  const creditNote = row.original.total_credit_note;
  const creditNoteId = row.original.credit_note_id;

  if (creditNote > 0) {
    return (
      <a href={`/customerportal/invoices-payments-view/${creditNoteId}`}>
        {creditNote}
      </a>
    );
  }
  return <span></span>;
};

CreditNoteLink.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      total_credit_note: PropTypes.number,
      credit_note_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  }).isRequired,
};

const StatusCell = ({ row }) => {
  const status = row.original.invoicing_status?.title || '';
  const statusid = row.original.invoicing_status?.id || '';
  const bgColor = row.original.invoicing_status?.bg_color || '#eee';
  //const textColor = row.original.invoicing_status?.color || '#333';
  
    let iconClass = '';
    let bg_color = '';

  if (statusid == 1) {
    iconClass = 'fa fa-check';
    bg_color ='#0080006b';
  } else if (statusid == 2) {
    iconClass = 'fa fa-hourglass-2';
    bg_color ='#0000ff78';
  } else {
    iconClass = 'fa fa-times';
    bg_color ='#ff00005e';
  }
  return (
    <p
      style={{
        backgroundColor: bg_color,
        color: bgColor,
        fontWeight:'600',
        padding: '5px 10px',
        borderRadius: '4px',
        display: 'inline-block',
        textTransform: 'capitalize',
      }}
    >
      {status} <i className={iconClass}></i>
    </p>
  );
};

StatusCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      invoicing_status: PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        bg_color: PropTypes.string,
        color: PropTypes.string,
      }),
    }),
  }).isRequired,
};

// Column definitions
const columns = [
  {
    header: 'Invoice Number',
    accessorFn: (row) => `${row.invoice_number}`,
    Cell: InvoiceLink,
  },
  {
    accessorKey: 'date',
    header: 'Date',
  },
  
  {
    header: 'Total Sales',
    accessorFn: (row) => `${row.invoice_amount}`,
  },
  {
    header: 'Paid Amount',
    accessorFn: (row) => `${row.paid}`,
  },
  {
    header: 'Total Credit Note Amount',
    accessorFn: (row) => `${row.total_credit_note}`,
  },
  {
    header: 'Open Amount',
    accessorFn: (row) => `${row.open_amount}`,
  },
 
{
  header: 'Invoice Status',
  accessorKey: 'invoicing_status.title',
  Cell: StatusCell,
}

];

console.log(formData);
  return (
    <>
      <div className={`main-wrapper  customer-portal-main`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
        <div className="content container-fluid top-dashboardfilter" >
            <div className="row">
              <div className="col-xl-10 col-lg-10 col-md-10 col-12">
                <div className="card customer-details-group">
                  <div className="card-body">
                    <div className="row align-items-center">
                      <div className="col-xl-3 col-lg-3 col-md-3 col-12">
                        <div className="customer-details">
                          <div className="d-flex align-items-center"><span className="customer-widget-icon d-inline-flex"><i className="fe fe-airplay2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-airplay "><g><path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path><polygon points="12 15 17 21 7 21 12 15"></polygon></g></svg></i></span>
                            <div className="customer-details-cont">
                              <h6>Company Name</h6>
                              <p>{customer_info.company_name}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-3 col-lg-3 col-md-3 col-12">
                        <div className="customer-details">
                          <div className="d-flex align-items-center"><span className="customer-widget-icon d-inline-flex"><i className="fe fe-phone2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-phone "><g><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></g></svg></i></span>
                            <div className="customer-details-cont">
                              <h6>Phone Number</h6>
                              <p>{customer_info.company_phone}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-3 col-lg-3 col-md-3 col-12">
                        <div className="customer-details">
                          <div className="d-flex align-items-center"><span className="customer-widget-icon d-inline-flex"><i className="fe fe-mail2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-mail "><g><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></g></svg></i></span>
                            <div className="customer-details-cont">
                              <h6>Email Address</h6>
                              <p>{customer_info.company_email}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    
                      
                      <div className="col-xl-3 col-lg-3 col-md-3 col-12">
                        <div className="customer-details">
                          <div className="d-flex align-items-center"><span className="customer-widget-icon d-inline-flex"><i className="fe fe-globe2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-globe "><g><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></g></svg></i></span>
                            <div className="customer-details-cont">
                              <h6>Website</h6>
                              <p><a href={customer_info.company_website}  rel="noopener noreferrer" target="_blank">{customer_info.company_website}</a></p>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>
                <div className="col-xl-2 col-lg-2 col-md-2 col-12">
                <div className="card ">
                  <div className="card-body">
                    <div className="row align-items-center">
                      <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                        <div className="customer-details" style={{textAlign:'center', padding:'30px', }}>
                           <a href="/customerportal/update-profile" className="btn btn-primary"  >
                            <i className="fa fa-user" />  Profile
                          </a>
                        </div>
                      </div>
                    
                      
                    </div>
                  </div>
                </div>
              </div>
           
            </div>
              <div className="row" >            
                    <div className="col-md-2">
                       <label>Select Season</label>
                         {allseason.length > 0 && (
                          <Select
                            options={allseason}
                            name="season_id"
                            value={allseason.find(option => option.value == formData.season_id) || null} 
                            onChange={(selectedOption) => {
                                    handleSelectChangeCustomer(selectedOption);
                                }}
                          />
                         )}
                       
                      
                        
                      </div>
                      <div className="col-md-10">
                        <div className="" style={{float:'right'}}>
                            <button onClick={downloadpdf} className="btn btn-primary me-1" >
                            Export PDF <i className="fa fa-download" />
                          </button>
                        </div> 
                    </div>

                </div>
              </div>
           
          <div className="content container-fluid" id="downloadpdf">
                     
            <div className="row customer-boxes-contain" >
              <div className="col-xl-4 col-sm-4 col-12">
                <div className="card dashboard-card-border">
                  <div className="card-body">
                    <div className="row">
                       <div className="col-xl-9 col-sm-9 col-9">
                          <div className="dash-widget-header" style={{paddingTop:'10px'}}>
                               <div className="dash-count">
                                <h5 className="" style={{fontWeight:'300'}}>Total invoices</h5>
                                  <div className="dash-counts" style={{paddingTop:'5px'}}>
                                    <p>{dataBoxes.total_sale}</p>
                                </div>
                              </div>
                            </div>
                      </div>

                      <div className="col-xl-3 col-sm-3 col-3">
                          <div className="dash-widget-header">
                              <span className="dash-widget-icon bg-site">
                               <i className="fas fa-file-invoice-dollar"></i>



                              </span>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

               <div className="col-xl-4 col-sm-4 col-12">
                <div className="card dashboard-card-border">
                  <div className="card-body">
                    <div className="row">
                       <div className="col-xl-9 col-sm-9 col-9">
                          <div className="dash-widget-header" style={{paddingTop:'10px'}}>
                               <div className="dash-count">
                                <h5 className="" style={{fontWeight:'300'}}>Outstanding</h5>
                                  <div className="dash-counts" style={{paddingTop:'5px'}}>
                                    <p>{dataBoxes.credit_balance}</p>
                                </div>
                              </div>
                            </div>
                      </div>

                      <div className="col-xl-3 col-sm-3 col-3">
                          <div className="dash-widget-header">
                              <span className="dash-widget-icon bg-site2">
                                <i className="fa fa-hourglass-2	"></i>
                              </span>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

               <div className="col-xl-4 col-sm-4 col-12">
                <div className="card dashboard-card-border">
                  <div className="card-body">
                    <div className="row">
                       <div className="col-xl-9 col-sm-9 col-9">
                          <div className="dash-widget-header" style={{paddingTop:'10px'}}>
                              <div className="dash-count">
                              <h5 className="" style={{fontWeight:'300'}}>Overdue</h5>
                                <div className="dash-counts" style={{paddingTop:'5px'}}>
                                  <p>{dataBoxes.total_due_amount}</p>
                              </div>
                            </div>
                          </div>
                      </div>

                      <div className="col-xl-3 col-sm-3 col-3">
                          <div className="dash-widget-header">
                              <span className="dash-widget-icon bg-site3">
                             <i className="fa fa-euro"></i>

                              </span>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>        
            </div>

          <div className="row">
              <div className="col-md-12 col-sm-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title"> Invoices</h5>
                      </div>
                      <div className="col-auto">
                        <Link to="/customerportal/invoices-payments" className="btn-right btn btn-sm btn-outline-primary" > View All</Link>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                        <MaterialReactTable columns={columns} data={invoicedata}  enableColumnOrdering  />
                      </div>
                  </div>
                </div>
              </div>
  
                </div>

            <div className="row">
                      <div className="col-md-6 col-sm-6">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title"> Recent loads</h5>
                      </div>
                      <div className="col-auto">
                        {/* <Link to="/customer-balances" className="btn-right btn btn-sm btn-outline-primary" > View All</Link> */}
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive" style={{ maxHeight: '380px', overflowY: 'auto' }}>
                      <table className="table table-stripped table-hover">
                        <thead className="thead-light">
                          <tr>
                            <th>Date</th>
                            <th>Invoice Number</th>
                            <th>ETA Date</th>
                            <th>Details</th>
                        
                          </tr>
                        </thead>
                        <tbody>
                          {cusomerbalance.map((item, index) => {
                           

                            return (
                              <tr key={index}>
                                 <td>
                                  
                                    {item.loading_date}
                                    
                                </td>
                             
                                
                                <td>{item.invoice_number}</td>
                                <td>{item.eta_date}</td>
                                   <td>
                                 
                                    
                                    <Link className='btn btn-primary btn-block' to={`/customerportal/loadings-view/${item.id}`}>
                                      {'Access Loading'}
                                    </Link>
                               
                                </td>
                               
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
               <div className="col-md-6">
                    <div className="card">
                      <div className="card-header">
                        <h5 className="card-title">Product Analytics</h5>
                      </div>
                      <div className="card-body">
                        <div style={{ overflowX: 'auto', width: '100%' }}>
                            <div> 
                                <ReactApexChart options={sColStacked_caliber}  series={sColStacked_caliber.series} type="bar" height={350}/>
                            </div>
                          </div>
                      </div>
                    </div>
                </div>    
             </div>
           </div>
        </div>
      </div>
    </>
  );
};
export default CustomerDashboard;
